import { TimeRange, TimeSpan } from "@iventis/types";

export const timeRange = (from: TimeSpan, to: TimeSpan): TimeRange => `${from}-${to}`;

export const timeRangeFrom = (timeRange: TimeRange) => timeRange?.split("-")[0] as TimeSpan;

export const timeRangeTo = (timeRange: TimeRange) => timeRange?.split("-")[1] as TimeSpan;
